import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const B2CUsersList = lazy(() =>
    import('../../pages/B2CManagement/Users').then((module) => ({
        default: module.UsersList,
    }))
);
const B2CUserPurchaseHistory = lazy(() =>
    import('../../pages/B2CManagement/Users').then((module) => ({
        default: module.UserPurchaseHistory,
    }))
);
export function B2CUserContainer() {
    return (
        <Routes>
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent
                        type="LIST"
                        Component={<B2CUsersList />}
                    />
                }
            />
            <Route
                path={'purchase-history/:id'}
                element={
                    <LazyLoadComponent
                        type="PAGE"
                        Component={<B2CUserPurchaseHistory />}
                    />
                }
            />
        </Routes>
    );
}
